import {Navigate, Outlet} from "react-router-dom";
import {useStateContext} from "../../contexts/ContextProvider";
import PostHogPageViewTracker from "../analytics/PostHogPageViewTracker";

export default function GuestLayout() {

    const {token} = useStateContext();

    if(token){
        return <Navigate to={"/"}/>
    }

    return (
        <div className="h-full">
            <PostHogPageViewTracker />
            <Outlet/>
        </div>
    )
}
